import {SecurityService} from "navigation-common/SecurityService";
import InlineEdit from "@atlaskit/inline-edit";
import InlineDialog from "@atlaskit/inline-dialog";
import {Box} from "@atlaskit/primitives";
import Textfield from "@atlaskit/textfield";
import ErrorIcon from "@atlaskit/icon/glyph/error";
import {token} from "@atlaskit/tokens";
import {R400} from "@atlaskit/theme/colors";
import {css} from "@emotion/react";
import {MenuItem} from "navigation-common/types/navigation-types";
import classNames from "classnames";
import React from "react";
import {fontSize as getFontSize} from "@atlaskit/theme/constants";

export const NameItemInputField = (props: { menuItem: MenuItem, changeTrigger: (value: string) => void, newMenuItemKey: string }) => {

    const fontSize = getFontSize();
    const gridSize = token('space.100', '8px');
    const ReadViewContainer = css({
        display: 'flex',
        fontSize: `${fontSize}px`,
        lineHeight: `calc((${gridSize} * 2.5) / ${fontSize})`,
        maxWidth: '100%',
        minHeight: `calc((${gridSize} * 2.5) / ${fontSize}em`,
        padding: `${gridSize}px calc(${gridSize} - 2px)`,
        wordBreak: 'break-word',
    });

    const validate = async (value: string) => {
        const validateObject = await new Promise<{ value: string; error: string; } | undefined>(
            (resolve) => {
                if (SecurityService.isValidName(value)) {
                    resolve(undefined);
                }
                resolve({value, error: "Please do not use: < > \\ & % { } or empty"});
            });
        if (validateObject && validateObject.value === value) {
            return validateObject.error;
        }
        return undefined;
    };

    return (
        <InlineEdit
            defaultValue={props.menuItem.name}
            editView={({errorMessage, ...fieldProps}) => (
                <InlineDialog
                    isOpen={fieldProps.isInvalid}
                    content={<Box id="error-message">{errorMessage}</Box>}
                    placement="top-start">
                    <Textfield {...fieldProps} autoFocus
                               elemAfterInput={
                                   fieldProps.isInvalid && (
                                       <Box>
                                           <ErrorIcon
                                               label="error"
                                               primaryColor={token('color.icon.danger', R400)}
                                           />
                                       </Box>
                                   )
                               }
                    />
                </InlineDialog>
            )}
            readView={() => (
                <div
                    css={css(ReadViewContainer)}
                    className={classNames({"empty": !props.menuItem.name})}
                    data-testid="read-view"
                >
                    {props.menuItem.name || 'Enter name'}
                </div>
            )}
            onConfirm={(value) => props.changeTrigger(value)}
            startWithEditViewOpen={props.newMenuItemKey == props.menuItem.key}
            validate={validate}
            hideActionButtons
        />
    );
}
